import React from 'react';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { useTheme } from '../ThemeContext';
import LogoDark from '../assets/m3-logo-dark.svg';
import LogoLight from '../assets/m3-logo-light.svg';

export default function Home() {
  const { theme } = useTheme();
  const logo = theme === 'dark' ? LogoLight : LogoDark;

  return (
    <div className="section">
      <div className="text-center mb-5">
        <img src={logo} alt="M3 Computing" style={{ maxWidth: '360px', width: '100%' }} />
      </div>

      <h1 className="fw-bold mb-3">Cloud expertise that leaves your team stronger.</h1>
      <p className="fs-5 mb-2">
        M3 Computing is a boutique consultancy specializing in cloud-native architecture, SaaS
        development, and technical education. We design and build solutions your team can
        understand, own, and evolve — without depending on us to keep them running.
      </p>
      <p className="fs-5 mb-5">
        Every engagement starts with understanding your mission. We bring senior-level depth
        across cloud strategy, platform engineering, and SaaS development, and we back every
        delivery with the knowledge transfer to make it last.
      </p>

      <Row className="g-4">
        <Col md={4}>
          <Card className="h-100 m3-service-card">
            <Card.Body className="d-flex flex-column">
              <Card.Title as="h3">Consulting</Card.Title>
              <Card.Text className="flex-grow-1">
                Strategic guidance on cloud architecture, SaaS strategy, and cloud cost
                optimization. We help you make the right decisions before they become expensive
                to undo.
              </Card.Text>
              <Link to="/consulting" className="m3-card-link mt-2">Learn more →</Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="h-100 m3-service-card">
            <Card.Body className="d-flex flex-column">
              <Card.Title as="h3">Development</Card.Title>
              <Card.Text className="flex-grow-1">
                Cloud-native and SaaS development delivered by a senior engineer who stays on
                the work. From platform engineering to full-cycle product builds.
              </Card.Text>
              <Link to="/development" className="m3-card-link mt-2">Learn more →</Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="h-100 m3-service-card">
            <Card.Body className="d-flex flex-column">
              <Card.Title as="h3">Education</Card.Title>
              <Card.Text className="flex-grow-1">
                Custom training programs, video courses, and technical mentoring designed to
                build lasting capability inside your engineering team.
              </Card.Text>
              <Link to="/education" className="m3-card-link mt-2">Learn more →</Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
